import { Component, Input } from '@angular/core';
import { Store } from 'src/app/core/stores.service';

@Component({
  selector: 'app-store-details-general-ownership',
  templateUrl: './store-details-general-ownership.component.html',
  styleUrls: ['./store-details-general-ownership.component.scss'],
})
export class StoreDetailsGeneralOwnershipComponent {
  @Input() store?: Store;

  getOwnerName(): string {
    if (!this.store?.owner_firstname && !this.store?.owner_lastname) {
      return '-';
    }

    const name_lenght = (this.store.owner_firstname?.length || 0) + (this.store.owner_lastname?.length || 0);
    const fullname = (this.store.owner_firstname + ' ' + this.store.owner_lastname).trim();

    if (name_lenght > 30) {
      return fullname.slice(0, 30) + '...';
    }

    return fullname;
  }
}
